
import { defineComponent, inject, provide, reactive, ref, watch } from "vue";
import { summaryOfQualifiedRateData, unqualifiedProblemDetails, summaryOfUnqualifiedRateData } from "@/request/view/productionInstruction";
import { PQCProductOption, currentYear, yearOption } from '@/views/productDaily/serve/option';
import { debounce } from "@/utils";

import processStatisticsYear from '@/views/productDaily/components/quality/PassRate/processStatistics/year.vue';
import processStatisticsMonth from '@/views/productDaily/components/quality/PassRate/processStatistics/month.vue';
import modelCascader from '@/components/cascader/index.vue';
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    modelCascader,
    processStatisticsYear,
    processStatisticsMonth,
  },
  setup(props, context) {
    const route = useRoute();
    const requestPayload = reactive({
      modelSpecifications: null,
      produceOrTpc: route.meta.produceOrTpc,
      year: currentYear,
    });


    const PQCkeyList = reactive([]);
    provide('PQCkeyList', PQCkeyList);
    const initPQCkeyList = () => {
      PQCkeyList.length = 0;
      PQCProductOption.forEach((item) => {
        PQCkeyList.push(item.label)
      });
      PQCkeyList.push('合计');
    }

    const statisticsData = ref(null);

    const getRateData = () => {
      statisticsData.value = null;
      if (requestPayload.modelSpecifications === null) return;
      summaryOfQualifiedRateData(requestPayload).then((res: any) => {
        if (res.code === 200 && res.message === '成功') {
          statisticsData.value = res.data;
        }
      });
    };

    const unQualifiedData = ref(null);

    // 获取不合格汇总数据
    const getUnQualified = () => {
      unQualifiedData.value = null;
      summaryOfUnqualifiedRateData({
        year: requestPayload.year,
        produceOrTpc: route.meta.produceOrTpc
      }).then((res: any) => {
        if (res.code === 200 && res.message === '成功') {
          unQualifiedData.value = res.data;
        }
      })
    };

    const handleSearch = debounce(() => {
      getRateData();
      getUnQualified();
    }, 100);

    const handleSelectModelSpecifications = (e) => {
      // const [machine, type] = e;
      // requestPayload.modelSpecifications = type === undefined ? null : type;
      // handleSearch();
    };


    const init = () => {
      requestPayload.year = currentYear;
      requestPayload.modelSpecifications = null;
      handleSearch();
      initPQCkeyList();
    };

    const tabActivekey = inject('tabActivekey', null);

    watch(() => tabActivekey, (val) => {
      if (val && val.value && val.value === 'summaryOfpassRate') {
        init();
      }
    }, {
      immediate: true,
      deep: true
    });


    return {
      handleSearch,
      yearOption,
      PQCkeyList,
      PQCProductOption,
      requestPayload,
      handleSelectModelSpecifications,
      statisticsData,
      unQualifiedData,
    };
  },
});
